import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from './loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  loading$!: Observable<boolean>;
  message$!: Observable<string>;

  constructor(private loader: LoaderService) {
    this.loading$ = this.loader.loading$;
    this.message$ = this.loader.message$;
  }
}
